import styled from 'styled-components';

const BenefitsStyle = styled.section`
	--benefitsSectionDistance: var(--sp13x);
	--benefitsItemsDistance: var(--sp9x);
	--itemTitleDescDistance: var(--sp4x);

	--itemContentBlockWidth: var(--sp71x);

	--olive1Width: var(--sp109x);
	--olive1Height: var(--sp67x);

	--olive2Width: var(--sp122x);
	--olive2Height: var(--sp78x);

	--olive3Width: var(--sp102x);
	--olive3Height: var(--sp69x);

	--olive4Width: var(--sp120x);
	--olive4Height: var(--sp89x);

	--olive5Width: var(--sp105x);
	--olive5Height: var(--sp81x);

	--olive2topDistance: 0;

	--topOliveLeftDistance: var(--sp52x);

	--olive3rightDistance: 0;
	--olive3topDistance: 0;

	--olive4rightDistance: calc(-1 * var(--sp14x));
	--olive4topDistance: calc(-1 * var(--sp22x));

	--olive5rightDistance: calc(-1 * var(--sp19x));
	--olive5topDistance: calc(-1 * var(--sp10x));

	/* margin-top: var(--benefitsSectionDistance); */
	margin-top: var(--sectionDistance);
	margin-bottom: calc(var(--sectionDistance) / 2);
	overflow: hidden;

	.title-block {
		text-align: center;
	}

	.benefits-items-wrapper {
		position: relative;
		width: fit-content;
		display: flex;
		flex-direction: column;
		margin: var(--benefitsItemsDistance) auto 0;
	}

	.top-block {
		display: flex;
	}

	.bottom-block {
		display: flex;
	}

	.editor-wrapper {
		text-align: center;
		margin-top: var(--itemTitleDescDistance);

		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
	}

	.empty-div {
		width: var(--olive1Width);
		height: var(--olive1Height);
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}

	.item-inner-block {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;

		svg {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
		}

		&.olive1 {
			width: var(--olive1Width);
			height: var(--olive1Height);

			transform: translateX(var(--topOliveLeftDistance));
		}

		&.olive2 {
			width: var(--olive2Width);
			height: var(--olive2Height);

			transform: translateX(var(--topOliveLeftDistance));
			z-index: 2;
		}

		&.olive3 {
			width: var(--olive3Width);
			height: var(--olive3Height);

			transform: translate(var(--olive3rightDistance), var(--olive3topDistance));
		}

		&.olive4 {
			width: var(--olive4Width);
			height: var(--olive4Height);

			transform: translate(var(--olive4rightDistance), var(--olive4topDistance));
			z-index: 4;
		}

		&.olive5 {
			width: var(--olive5Width);
			height: var(--olive5Height);

			transform: translate(var(--olive5rightDistance), var(--olive5topDistance));
		}
	}

	.item-content-block {
		position: relative;
		width: var(--itemContentBlockWidth);
	}

	.item-title {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}

	.title-block {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--benefitsSectionDistance: var(--sp10x);
		--benefitsItemsDistance: var(--sp8x);
		--itemTitleDescDistance: var(--sp3x);

		--itemContentBlockWidth: var(--sp53x);

		--olive1Width: var(--sp82x);
		--olive1Height: var(--sp51x);

		--olive2Width: var(--sp91x);
		--olive2Height: var(--sp58x);

		--olive3Width: var(--sp77x);
		--olive3Height: var(--sp52x);

		--olive4Width: var(--sp90x);
		--olive4Height: var(--sp67x);

		--olive5Width: var(--sp79x);
		--olive5Height: var(--sp61x);

		--topOliveLeftDistance: var(--sp39x);

		--olive3rightDistance: 0;
		--olive3topDistance: 0;

		--olive4rightDistance: calc(-1 * var(--sp12x));
		--olive4topDistance: calc(-1 * var(--sp18x));

		--olive5rightDistance: calc(-1 * var(--sp16x));
		--olive5topDistance: calc(-1 * var(--sp6x));
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--benefitsSectionDistance: var(--sp8x);
		--benefitsItemsDistance: var(--sp7x);
		--itemTitleDescDistance: var(--sp2x);

		--itemContentBlockWidth: var(--sp42x);

		--olive1Width: var(--sp65x);
		--olive1Height: var(--sp40x);

		--olive2Width: var(--sp72x);
		--olive2Height: var(--sp46x);

		--olive3Width: var(--sp61x);
		--olive3Height: var(--sp41x);

		--olive4Width: var(--sp71x);
		--olive4Height: var(--sp53x);

		--olive5Width: var(--sp62x);
		--olive5Height: var(--sp48x);

		--topOliveLeftDistance: var(--sp31x);

		--olive3rightDistance: 0;
		--olive3topDistance: 0;

		--olive4rightDistance: calc(-1 * var(--sp8x));
		--olive4topDistance: calc(-1 * var(--sp13x));

		--olive5rightDistance: calc(-1 * var(--sp12x));
		--olive5topDistance: calc(-1 * var(--sp3-5x));
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--benefitsSectionDistance: var(--sp7x);
		--benefitsItemsDistance: var(--sp5x);
		--itemTitleDescDistance: var(--sp2x);

		--itemContentBlockWidth: var(--sp38x);

		--olive1Width: var(--sp58x);
		--olive1Height: var(--sp36x);

		--olive2Width: var(--sp65x);
		--olive2Height: var(--sp41x);

		--olive3Width: var(--sp54x);
		--olive3Height: var(--sp37x);

		--olive4Width: var(--sp63x);
		--olive4Height: var(--sp47x);

		--olive5Width: var(--sp56x);
		--olive5Height: var(--sp43x);

		--topOliveLeftDistance: var(--sp28x);

		--olive3rightDistance: 0;
		--olive3topDistance: 0;

		--olive4rightDistance: calc(-1 * var(--sp7x));
		--olive4topDistance: calc(-1 * var(--sp12x));

		--olive5rightDistance: calc(-1 * var(--sp11x));
		--olive5topDistance: calc(-1 * var(--sp4x));
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--benefitsSectionDistance: var(--sp6x);
		--benefitsItemsDistance: var(--sp4x);
		--itemTitleDescDistance: var(--sp2x);

		--itemContentBlockWidth: var(--sp35x);

		--olive1Width: var(--sp54x);
		--olive1Height: var(--sp33x);

		--olive2Width: var(--sp61x);
		--olive2Height: var(--sp39x);

		--olive3Width: var(--sp51x);
		--olive3Height: var(--sp34x);

		--olive4Width: var(--sp59x);
		--olive4Height: var(--sp44x);

		--olive5Width: var(--sp52x);
		--olive5Height: var(--sp40x);

		--topOliveLeftDistance: var(--sp26x);

		--olive3rightDistance: 0;
		--olive3topDistance: 0;

		--olive4rightDistance: calc(-1 * var(--sp7x));
		--olive4topDistance: calc(-1 * var(--sp12x));

		--olive5rightDistance: calc(-1 * var(--sp10x));
		--olive5topDistance: calc(-1 * var(--sp4x));
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--benefitsSectionDistance: var(--sp5x);
		--benefitsItemsDistance: var(--sp4x);
		--itemTitleDescDistance: var(--sp1-5x);

		--itemContentBlockWidth: var(--sp33x);

		--olive1Width: var(--sp43x);
		--olive1Height: var(--sp27x);

		--olive2Width: var(--sp48x);
		--olive2Height: var(--sp31x);

		--olive3Width: var(--sp40x);
		--olive3Height: var(--sp27x);

		--olive4Width: var(--sp47x);
		--olive4Height: var(--sp35x);

		--olive5Width: var(--sp41x);
		--olive5Height: var(--sp32x);

		--topOliveLeftDistance: var(--sp20x);

		--olive3rightDistance: 0;
		--olive3topDistance: 0;

		--olive4rightDistance: calc(-1 * var(--sp5x));
		--olive4topDistance: calc(-1 * var(--sp9x));

		--olive5rightDistance: calc(-1 * var(--sp8x));
		--olive5topDistance: calc(-1 * var(--sp4x));
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--benefitsSectionDistance: var(--sp5x);
		--benefitsItemsDistance: var(--sp4x);
		--itemTitleDescDistance: var(--sp1-5x);

		--itemContentBlockWidth: var(--sp32x);

		--olive1Width: var(--sp44x);
		--olive1Height: var(--sp28x);

		--olive2Width: var(--sp44x);
		--olive2Height: var(--sp26x);

		--olive3Width: var(--sp43x);
		--olive3Height: var(--sp33x);

		--olive4Width: var(--sp44x);
		--olive4Height: var(--sp34x);

		--olive5Width: var(--sp44x);
		--olive5Height: var(--sp33x);

		--topOliveLeftDistance: var(--sp1x);

		--olive3rightDistance: var(--sp25x);
		--olive3topDistance: var(--sp25x);

		--olive4rightDistance: calc(-1 * var(--sp40x));
		--olive4topDistance: calc(-1 * var(--sp5x));

		--olive5rightDistance: var(--sp43x);
		--olive5topDistance: calc(-1 * var(--sp38x));

		.bottom-block {
			flex-wrap: wrap;
		}
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--benefitsSectionDistance: var(--sp4x);
		--benefitsItemsDistance: var(--sp4x);
		--itemTitleDescDistance: var(--sp1-5x);

		--itemContentBlockWidth: var(--sp32x);

		--olive1Width: 100%;
		--olive1Height: var(--sp28x);

		--olive2Width: 100%;
		--olive2Height: var(--sp26x);

		--olive3Width: 100%;
		--olive3Height: var(--sp33x);

		--olive4Width: 100%;
		--olive4Height: var(--sp33x);

		--olive5Width: 100%;
		--olive5Height: var(--sp33x);

		--topOliveLeftDistance: 0;

		--olive2topDistance: calc(-1 * var(--sp2x));

		--olive3rightDistance: 0;
		--olive3topDistance: calc(-1 * var(--sp11x));

		--olive4rightDistance: 0;
		--olive4topDistance: calc(-1 * var(--sp7x));

		--olive5rightDistance: 0;
		--olive5topDistance: calc(-1 * var(--sp3x));

		.benefits-items-wrapper {
			width: 100%;
		}

		.top-block {
			flex-direction: column;
		}

		.bottom-block {
			flex-wrap: unset;
			flex-direction: column-reverse;
		}

		.item-inner-block {
			&.olive2 {
				transform: translate(var(--topOliveLeftDistance), var(--olive2topDistance));
			}
		}
	}
`;

export default BenefitsStyle;
